module.exports = __webpack_public_path__ + "static/media/YF41_5.6a1327b4.jpg";